import React, { useState, useEffect } from "react";
import { lockScroll, unlockScroll } from "../utils/ScrollLock.js";

const MobileHeader = ({ data, current, onLanguageChange }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (isMobileMenuOpen) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return unlockScroll;
  }, [isMobileMenuOpen]);

  if (!data) return null;

  const { logo, btnText, navigation } = data;

  const logoUrl = logo?.url
    ? logo.url
    : "";

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleNavItemClick = (url) => {
    setIsMobileMenuOpen(false);
    setTimeout(() => {
      const target = document.querySelector(url);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  return (
    <>
      {/* Mobile Header */}
      <div className="mobile-header">
        <a className="logo" href="/">
          <img src={logoUrl} alt="Logo" />
        </a>
        <div className="mobile-controls">
          <div className="switch-lang mobile-lang">
            <span
              onClick={() => onLanguageChange("uk")}
              className={current === "uk" ? "active" : ""}
            >
              Укр
            </span>
            <span className="splitter"></span>
            <span
              onClick={() => onLanguageChange("ru")}
              className={current === "ru" ? "active" : ""}
            >
              Рус
            </span>
            {/* <span className="splitter"></span>
            <span
              onClick={() => onLanguageChange("en")}
              className={current === "en" ? "active" : ""}
            >
              Eng
            </span> */}
          </div>
          <button
            className={`burger-button ${isMobileMenuOpen ? "active" : ""}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
        <ul className="mobile-navigation">
          {navigation?.map((item) => (
            <li key={item.id}>
              <button onClick={() => handleNavItemClick(item.url)}>
                {item.label}
              </button>
            </li>
          ))}
        </ul>
        <div className="mobile-menu-bottom">
          <button
            className="transparent-button mobile-btn"
            onClick={() => handleNavItemClick("#contacts")}
          >
            {btnText}
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileHeader;
